import Toggle from './Toggle'

const OwnRepliesToggle = ({
    showOwnComments,
    onToggle
}: {
    showOwnComments: boolean
    onToggle: (isEnabled: boolean) => Promise<void>
}) => {
    return (
        <Toggle
            loading={false}
            checked={showOwnComments}
            onToggle={onToggle}
            label={'Show own replies'}
            tooltip={
                'Toggling this will show or hide replies made by the profiles included in this search'
            }
            disabled={false}
            id={'excludeOwnCommentsCheckbox'}
            size={'medium'}
        />
    )
}

export default OwnRepliesToggle
